import { createFetcher } from './Fetcher';

export default createFetcher(({ callToActionStore }, { showId, ctaLocation }) => ({
    fetch: () => showId && callToActionStore.fetchCallToActionButtons(showId, ctaLocation),
    isLoading: callToActionStore.fetchCallToActionButtons.pending,
    input: [showId, ctaLocation],
}));
